import productInstance from './instance'

const updateProduct = (productId, data) => {
  return productInstance.put('/products/' + productId, data)
}

export default updateProduct
